import React from 'react';
import { graphql } from 'gatsby';
import { RichText } from 'prismic-reactjs';

import { Container, Spacer } from '@styles';

import PageHeader from '@common/PageHeader';
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from 'react-accessible-accordion';
import 'react-accessible-accordion/dist/fancy-example.css';

const RenderBody = ({ home }) => {
  const title = home.banner_title;
  const subtitle = home.banner_subtitle;
  const icon = home.icon;
  const faqArray = home.faq;

  return (
    <>
      <PageHeader
        title={RichText.asText(title)}
        subtitle={RichText.asText(subtitle)}
        imageUrl={icon.url}
        imageAlt={icon.alt}
      />
      <Spacer break2 />
      <Container normal>
        <Accordion allowMultipleExpanded={false} allowZeroExpanded={true}>
          {faqArray.map((reference, i) => (
            <AccordionItem allowMultipleExpanded="false" key={i}>
              <AccordionItemHeading>
                <AccordionItemButton>{reference.question}</AccordionItemButton>
              </AccordionItemHeading>
              <AccordionItemPanel>
                <p>{reference.answer}</p>
              </AccordionItemPanel>
            </AccordionItem>
          ))}
        </Accordion>
      </Container>
    </>
  );
};

export default ({ data }) => {
  const doc = data.prismic.allFaqs.edges.slice(0, 1).pop();

  if (!doc) return null;
  return <RenderBody home={doc.node} />;
};

export const query = graphql`
  {
    prismic {
      allFaqs {
        edges {
          node {
            banner_title
            banner_subtitle
            icon
            faq {
              question
              answer
            }
          }
        }
      }
    }
  }
`;
